import { useCallback, useEffect, useRef, useState } from "react"
import { getSections } from "../../services/sectionService";
import { SectionModel } from "./models/SectionModel";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "../../../setup";

export const useSections = () => {
    const { user } = useSelector((root: RootState) => root.auth, shallowEqual);
    const isMountedRef = useRef(false);
    const [sections, setSections] = useState<SectionModel[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const loadSections = useCallback(async () => {
        if(!isMountedRef.current || !user)
            return;
        setLoading(true);
        try {
            const _data = await getSections();
            if(isMountedRef.current)
                setSections(_data);
        }
        finally {
            if(isMountedRef.current)
                setLoading(false);
        }
    }, []);
    
    useEffect(() => {
        loadSections();
    }, [loadSections]);
    
    return { sections, loading, loadSections }
}